import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

import InputUtils from 'helpers/inputUtils';

const inputUtils = new InputUtils();

// Create styles
const styles = StyleSheet.create({
  title: {
    fontSize: 20,
    textAlign: 'center',
    color: 'red',
    marginTop: 30,
    marginBottom: 10,
  },
  subtitle: {
    fontSize: 10,
    textAlign: 'center',
    marginBottom: 15,
  },
  table: {
    width: '100%',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#808080',
    padding: 5,
  },
  tableHeaderCell: {
    color: 'white',
    fontSize: 9,
    fontWeight: 'bold',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    padding: 5,
    backgroundColor: 'white',
  },
  tableRowAlt: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    padding: 5,
    backgroundColor: '#f9f9f9',
  },
  powerUnitColumn: {
    flex: 1,
    fontSize: 9,
  },
  yearColumn: {
    flex: 1,
    fontSize: 9,
  },
  makeModelColumn: {
    flex: 2,
    fontSize: 9,
  },
  vinColumn: {
    flex: 2,
    fontSize: 9,
  },
  bodyTypeColumn: {
    flex: 1,
    fontSize: 9,
  },
  classColumn: {
    flex: 1,
    fontSize: 9,
  },
});

const VehiclesSchedule = ({ vehicles }) => (
  <>
    <Text style={styles.title}>Vehicle Schedule</Text>
    <Text style={styles.subtitle}>
      It is hereby noted and agreed that only the vehicle(s) specified
      in the schedule will be covered:
    </Text>

    <View style={styles.table}>
      <View style={styles.tableHeader}>
        <Text
          style={[styles.tableHeaderCell, styles.powerUnitColumn]}
        >
          Power Unit #
        </Text>
        <Text style={[styles.tableHeaderCell, styles.yearColumn]}>
          Year
        </Text>
        <Text
          style={[styles.tableHeaderCell, styles.makeModelColumn]}
        >
          Make/Model
        </Text>
        <Text style={[styles.tableHeaderCell, styles.vinColumn]}>
          VIN
        </Text>
        <Text style={[styles.tableHeaderCell, styles.bodyTypeColumn]}>
          Body Type
        </Text>
        <Text style={[styles.tableHeaderCell, styles.classColumn]}>
          Class
        </Text>
      </View>

      {(!vehicles || vehicles?.length === 0) && (
        <View>
          <Text
            style={{
              width: '100%',
              padding: 5,
              textAlign: 'center',
              fontSize: 10,
            }}
          >
            No vehicles found
          </Text>
        </View>
      )}

      {vehicles?.map((vehicle, index) => (
        <View
          key={index + 1}
          style={
            index % 2 === 0 ? styles.tableRow : styles.tableRowAlt
          }
        >
          <Text style={styles.powerUnitColumn}>{index + 1}</Text>
          <Text style={styles.yearColumn}>{vehicle.year}</Text>
          <Text style={styles.makeModelColumn}>
            {vehicle.make} {vehicle.model}
          </Text>
          <Text style={styles.vinColumn}>{vehicle.vin}</Text>
          <Text style={styles.bodyTypeColumn}>
            {inputUtils.capitalizeFirstLetter(vehicle.bodyTypeKey)}
          </Text>
          <Text style={styles.classColumn}>{vehicle.classKey}</Text>
        </View>
      ))}
    </View>
  </>
);

export default VehiclesSchedule;
